import { FunctionComponent, ReactElement, ReactNode } from "react";
import { RouterContextType } from "../context";
import useRouterContext from "../hooks/useRouterContext";

interface Props {
  children: (context: RouterContextType) => ReactNode;
}

export const WithRouterContext: FunctionComponent<Props> = ({ children }) => {
  const context = useRouterContext();

  return children(context) as ReactElement<unknown> | null;
};

export default WithRouterContext;
